import type { PaymentRetryRefusal } from '@sharedlib/dtos/dto/accounts/billing-payment-retry.dto';

/** The toast for each way a collection can be refused. A decline is an answer, not an error. */
export const RETRY_REFUSAL_TOAST: Readonly<Record<PaymentRetryRefusal, string>> = {
  payment_declined: 'That payment was declined again. Try a different payment method.',
  payment_method_required: 'There is no payment method on file. Add one to continue.',
  retry_pending: "Payment submitted. We'll update your subscription as soon as it settles.",
  // Reached only from a card-update collection: a Pay now refusal carries a challenge instead.
  authentication_required: 'Your bank needs to confirm this payment. Select Pay now to continue.',
};
